import { Box, styled } from '@withjoy/joykit';

export { getAmountButtonOverrides } from '@shared/utils/style/buttonOverrides';

export const StyledAmountButtonsContainer = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
`;
